import * as DialogPrimitive from '@radix-ui/react-dialog';
import { ReactNode } from 'react';

interface DialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title?: string;
  description?: string;
  children: ReactNode;
  trigger?: ReactNode;
  className?: string;
  onOpenAutoFocus?: (event: Event) => void;
}

export const Dialog = ({
  open,
  onOpenChange,
  title,
  description,
  children,
  trigger,
  className,
  onOpenAutoFocus,
}: DialogProps) => (
  <DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
    {trigger && (
      <DialogPrimitive.Trigger asChild>
        {trigger}
      </DialogPrimitive.Trigger>
    )}
    <DialogPrimitive.Portal>
      <DialogPrimitive.Overlay className="dialog-overlay" />
      <DialogPrimitive.Content 
        className={`dialog-content${className ? ` ${className}` : ''}`}
        onOpenAutoFocus={onOpenAutoFocus}
      >
        {title && (
          <DialogPrimitive.Title className="dialog-title">
            {title}
          </DialogPrimitive.Title>
        )}
        {description && (
          <DialogPrimitive.Description className="dialog-description">
            {description}
          </DialogPrimitive.Description>
        )}
        {children}
      </DialogPrimitive.Content>
    </DialogPrimitive.Portal>
  </DialogPrimitive.Root>
);

export const DialogClose = DialogPrimitive.Close;
